
































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { MountingPortal } from 'portal-vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { MobileMenuProps } from './types';
import SvgIcon from '@/components/SvgIcon';
import SlideMenu from '@/components/SlideMenu';
import Button from '@/components/Controls/Button';
import { http } from '@/http';

@Component({
    components: {
        SvgIcon,
        SlideMenu,
        Button,
        MountingPortal,
    },
})
export default class MobileMenu extends Vue implements MobileMenuProps {
    /**
     *
     */
    @Prop()
    public readonly id!: string;
    /**
     *
     */
    @Prop()
    public readonly url!: string;
    /**
     * TODO type
     */
    public items: Array<any> = [];
    /**
     *
     */
    public active: boolean = false;
    /**
     *
     */
    public badgeValue!: number | string | null;
    /**
     *
     */
    public show() {
        this.active = true;
    }
    /**
     *
     */
    public hide() {
        this.active = false;
    }
    /**
     *
     */
    public onTransitionEnter(el: HTMLElement) {
        disableBodyScroll(el);
        document.body.classList.add('mobile-menu-on');

        if (!this.items.length) {
            this.fetchItems();
        }
    }
    /**
     *
     */
    public onTransitionAfterEnter(el: HTMLElement) {}
    /**
     *
     */
    public onTransitionBeforeLeave(el: HTMLElement) {
        enableBodyScroll(el);
    }
    /**
     *
     */
    public onTransitionAfterLeave() {
        document.body.classList.remove('mobile-menu-on');
    }
    /**
     *
     */
    public async fetchItems() {
        const { id, url } = this.$props;

        const currentPath = window.location.pathname;

        if (!url) {
            console.warn(`[${this.$options.name}]: url does not specified`);
            return;
        }
        if (!id) {
            console.warn(`[${this.$options.name}]: id does not specified`);
            return;
        }

        try {
            this.$wait.start('fetchItems');
            const { data } = await http.get(url, {
                params: { id, currentPath },
            });
            this.items = data;
        } catch (error) {
            this.$errorLog(error);
        } finally {
            this.$wait.end('fetchItems');
        }
    }
    /**
     *
     */
    public async scrollActiveIntoView() {
        await this.$nextTick();

        const activeElement = this.$el.querySelector(`.navigator-item--active`);

        if (activeElement) {
            activeElement.scrollIntoView({
                block: 'nearest',
                behavior: 'smooth',
            });
        }
    }
    /**
     *
     */
    created() {
        const buttonPortal = document.getElementById('mobile-menu-widget-call-btn');
        this.badgeValue = buttonPortal?.getAttribute('data-badge-value') || null;
    }
}
